const allblogsdata = [
	{
		name: "Ways to run JS code",
		description:
      "In today’s time, Javascript is a popular client-side programming language. As a beginner in Javascript, you might be wondering where I can run my Javascript code.",
		img: "https://miro.medium.com/max/551/1*iyFBBLsQoI5nPfrhBkOafQ.png",
		link:
      "https://medium.com/@fahimalif077/two-popular-ways-to-run-javascript-code-cb6e463f80c6",
	},
	{
		name: "SSL certificate in 1 min",
		description: "First of all, what does SSL mean Well, SSL means Secure Sockets Layer. What is does for us? When you go to a website with a form to fill",
		img: "https://miro.medium.com/max/1050/1*Zz0ztGgICt0z192EqInOWg.jpeg",
		link:
      "https://fahimalif077.medium.com/ssl-certificate-in-1-min-8d2fadcd80c6",
	},
	{
		name: "What is Javascript and some useful string method in Javascript",
		description: "In this article, I am going to discuss some basics of the Javascript programming language.",
		img: "https://miro.medium.com/max/338/1*uDwWPZLF2gclNpr0GWT8Sw.png",
		link:
      "https://fahimalif077.medium.com/what-is-javascript-and-some-useful-string-method-in-javascript-323cdc5a5dc",
	},
	{
		name: "Data types, error handling, and IIFE in Javascript",
		description: `Data types
      There are two types of data type
      Primitive values
      Objects and functions.`,
		img: "https://static.javatpoint.com/images/java-data-types.png",
		link:
      "https://fahimalif077.medium.com/data-types-error-handling-and-iife-in-javascript-b52697e6d9bf",
	},
];

export default allblogsdata;
